//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

//import components
import OrderItems from '../orders/OrderItems';

export default function Order() {

    //get locale
    const { t } = useTranslation();

    return (
        <div className="col-span-12">
            <h2 className="text-2xl font-semibold mb-4">{t('my_orders')}</h2>
            <table className="min-w-full table-auto border-collapse bg-white rounded-lg shadow-md overflow-hidden">
                <thead>
                <tr className="bg-gray-100 text-left">
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('order_number')}</th>
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('payment_type')}</th>
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('payment_status')}</th>
                    <th className="px-6 py-3 text-sm font-medium text-gray-700">{t('total_price')}</th>
                </tr>
                </thead>
                <tbody>
                    <OrderItems />
                </tbody>
            </table>
        </div>
    );
}